import { createSlice, current, PayloadAction } from '@reduxjs/toolkit';
import { isShallowIdentical } from 'utils/isShallowIdentical';

export type SceneState = {
  doorsOpened: boolean;
  hasAllSelectedModelsLoaded: boolean;
  hasShownIntroAnimation: boolean;
  measurementsVisible: boolean;
  // two measurement states here. We need to differentiate between what the user want and what we can control on our side.
  userWantsMeasurementVisible: boolean;
};

const initialState: SceneState = {
  doorsOpened: false,
  hasAllSelectedModelsLoaded: false,
  hasShownIntroAnimation: false,
  measurementsVisible: false,
  userWantsMeasurementVisible: true
};

export const { reducer: sceneReducer, actions: sceneAction } = createSlice({
  name: 'scene',
  initialState,
  reducers: {
    setMeasurementsVisible: (
      state,
      { payload: measurementsVisible }: PayloadAction<SceneState['measurementsVisible']>
    ) => {
      if (isShallowIdentical(current(state).measurementsVisible, measurementsVisible)) {
        return;
      }

      return { ...state, measurementsVisible };
    },
    setUserWantsMeasurementVisible: (
      state,
      {
        payload: userWantsMeasurementVisible
      }: PayloadAction<SceneState['userWantsMeasurementVisible']>
    ) => {
      if (
        isShallowIdentical(current(state).userWantsMeasurementVisible, userWantsMeasurementVisible)
      ) {
        return;
      }

      return { ...state, userWantsMeasurementVisible };
    },
    setHasShownIntroAnimation: (
      state,
      { payload: hasShownIntroAnimation }: PayloadAction<SceneState['hasShownIntroAnimation']>
    ) => {
      if (isShallowIdentical(current(state).hasShownIntroAnimation, hasShownIntroAnimation)) {
        return;
      }

      return { ...state, hasShownIntroAnimation };
    },
    setHasAllSelectedModelsLoaded: (
      state,
      {
        payload: hasAllSelectedModelsLoaded
      }: PayloadAction<SceneState['hasAllSelectedModelsLoaded']>
    ) => {
      if (
        isShallowIdentical(current(state).hasAllSelectedModelsLoaded, hasAllSelectedModelsLoaded)
      ) {
        return;
      }

      return { ...state, hasAllSelectedModelsLoaded };
    },
    setDoorsOpened: (state, { payload: doorsOpened }: PayloadAction<SceneState['doorsOpened']>) => {
      if (isShallowIdentical(current(state).doorsOpened, doorsOpened)) {
        return;
      }

      return { ...state, doorsOpened };
    }
  }
});
